import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";
import { Line } from "react-chartjs-2";
import moment from 'moment';
import { components } from "react-select";
import SelectDropDown from "../../../selectdropdown/SelectDropDown";
import CardLessDataTableWithOutSearch from "../../../datatables/CardLessDataTableWithOutSearch";
import { SectionCard, EmptyState } from './naComponents';
import { THEME, GRADIENTS } from './naTheme';

// ─── Dropdown indicator (unchanged) ──────────────────────────────────────────

const DropdownIndicator = (props) => (
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <i className="fal fa-angle-down" />
    </components.DropdownIndicator>
  )
);

// ─── Timeline options (unchanged) ────────────────────────────────────────────

const selectionTimelines = [
  { value: 1, label: "Last 30 Days" },
  { value: 2, label: "Last 60 Days" },
  { value: 3, label: "3 Months"     },
  { value: 4, label: "Overall"      },
];

// ─── Chart options (unchanged) ────────────────────────────────────────────────

const chartOptions = {
  legend: { display: true, position: "bottom", labels: { boxWidth: 10 } },
  scales: { xAxes: [{ ticks: { display: false } }] },
  layout: { padding: { left: 16, right: 16, top: 10, bottom: 10 } },
  hover:  { cursor: 'pointer' },
};

// ─── GraphQL Query (unchanged) ────────────────────────────────────────────────

const GET_OFFLIE_RESULTS = gql`
  query($student_mobile: String, $timeline: Int) {
    getStudentExamResults(student_mobile: $student_mobile, timeline: $timeline) {
      year month date
      overall_total_rank overall_gained_rank
      overall_gained_marks overall_total_marks overall_avg
      exam_date paper_name
      student_marks {
        subject_id subject_wise_total_marks subject_wise_gained_rank
        subject_wise_gained_marks subject_wise_total_rank subject_wise_avg
      }
    }
  }
`;

// ─── Component ────────────────────────────────────────────────────────────────

class NAOfflineMarksDetails extends Component {

  // ── Column builder (unchanged logic) ───────────────────────────────────
  articlecolumFunc() {
    const articlecolumns = [
      { dataField: "exam_date", text: "Date",      sort: true },
      { dataField: "exam_name", text: "Exam Name", sort: true },
      { dataField: "overall",   text: "Overall",   formatter: this.actionsFormatterOverall },
    ];

    let examWiseSubjects = [];
    if (this.props.globals.offlineExamSubjects.length > 0) {
      const matchedExam = this.props.globals.exams
        .filter(item => item.id == +this.props.stateData.studentData.exam_id)[0];
      if (matchedExam) {
        matchedExam.exam_subjects.forEach(item1 => {
          this.props.globals.offlineExamSubjects.forEach(item2 => {
            if (item1.subject_id == item2.id) {
              examWiseSubjects.push({ value: item2.id, label: item2.subject });
            }
          });
        });
      }

      examWiseSubjects.forEach(item => {
        articlecolumns.push({
          dataField: item.label.replace(" ", "_"),
          text:      item.label,
          sort:      true,
          formatter: this.actionsFormatterSubject(item.value, item.label),
        });
      });
    }
    return articlecolumns;
  }

  // ── Cell formatters (unchanged logic) ──────────────────────────────────
  actionsFormatterOverall(cell, row) {
    return (
      <>
        <p style={{ margin: '2px 0', fontSize: '12px' }}>M: {row.gainedMarks} / {row.totalMarks}</p>
        <p style={{ margin: '2px 0', fontSize: '12px' }}>R: {row.gainedRank} / {row.totalRank}</p>
      </>
    );
  }

  actionsFormatterSubject(subjectId) {
    return (cell, row) => {
      const sub = row.individualMarks.find(item => item.subject_id == subjectId);
      if (sub) {
        return (
          <>
            <p style={{ margin: '2px 0', fontSize: '12px' }}>M: {sub.subject_wise_gained_marks} / {sub.subject_wise_total_marks}</p>
            <p style={{ margin: '2px 0', fontSize: '12px' }}>R: {sub.subject_wise_gained_rank}  / {sub.subject_wise_total_rank}</p>
          </>
        );
      }
      return (
        <>
          <p style={{ margin: '2px 0', fontSize: '12px' }}>M: —</p>
          <p style={{ margin: '2px 0', fontSize: '12px' }}>R: —</p>
        </>
      );
    };
  }

  render() {
    const offlineResults = this.props.offlineResults;

    if (offlineResults.loading) return <PreloaderTwo />;
    if (offlineResults.error !== undefined) {
      alert("Server Error. " + offlineResults.error.message);
      return null;
    }

    // ── Subject list (unchanged logic) ────────────────────────────────────
    let examWiseSubjects = [];
    if (this.props.globals.offlineExamSubjects.length > 0) {
      const matchedExam = this.props.globals.exams
        .filter(item => item.id == +this.props.stateData.studentData.exam_id)[0];
      if (matchedExam) {
        matchedExam.exam_subjects.forEach(item1 => {
          this.props.globals.offlineExamSubjects.forEach(item2 => {
            if (item1.subject_id == item2.id) {
              examWiseSubjects.push({ value: item2.id, label: item2.subject });
            }
          });
        });
      }
    }

    // ── Chart data preparation (unchanged logic) ──────────────────────────
    let labels = [], overAllAvg = [], marksDetails = [];

    if (offlineResults.getStudentExamResults.length > 0) {
      const ordered = [...offlineResults.getStudentExamResults].sort((a, b) => a.exam_date - b.exam_date);

      ordered.forEach(item => {
        labels.push(moment.unix(item.exam_date).format("DD-MM-YYYY"));
        overAllAvg.push(item.overall_avg);
      });

      const tableOrdered = [...offlineResults.getStudentExamResults].sort((a, b) => b.exam_date - a.exam_date);
      tableOrdered.forEach(item => {
        marksDetails.push({
          exam_date:      moment.unix(item.exam_date).format("DD-MM-YYYY"),
          exam_name:      item.paper_name,
          totalMarks:     item.overall_total_marks,
          gainedMarks:    item.overall_gained_marks,
          totalRank:      item.overall_total_rank,
          gainedRank:     item.overall_gained_rank,
          individualMarks: item.student_marks,
        });
      });
    }

    // Build per-subject datasets (unchanged logic)
    const colors = [
      'rgb(91,95,239)', 'rgb(139,92,246)', 'rgb(16,185,129)',
      'rgb(245,158,11)', 'rgb(239,68,68)', 'rgb(59,130,246)',
    ];
    const datasets = [
      { label: "Overall", fill: false, borderColor: THEME.primary, borderWidth: 2, pointRadius: 3, data: overAllAvg },
    ];
    examWiseSubjects.forEach((subject, idx) => {
      const subjectData = {
        label:       subject.label,
        fill:        false,
        borderColor: colors[idx % colors.length],
        borderWidth: 1,
        pointRadius: 2,
        data:        [],
      };
      const graphDetails = [...offlineResults.getStudentExamResults].sort((a, b) => a.exam_date - b.exam_date);
      graphDetails.forEach(detail => {
        const mark = detail.student_marks.find(m => m.subject_id == subject.value);
        subjectData.data.push(mark ? mark.subject_wise_avg : null);
      });
      datasets.push(subjectData);
    });

    const chartData = { labels, datasets };

    // ── Timeline selector header ──────────────────────────────────────────
    const timelineHeader = (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '150px' }}>
          <SelectDropDown
            options={selectionTimelines}
            handleChange={this.props.handleSelectTimelineChange}
            dropdownIndicator={{ DropdownIndicator }}
            stateData={this.props.stateData.marksSelectionTypeObj}
          />
        </div>
      </div>
    );

    return (
      <div className="offlineMarks" style={{ paddingTop: '8px' }}>

        {/* ── Chart Card ────────────────────────────────────────────── */}
        <div className="mb-3">
          <SectionCard
            title="Marks Trend"
            iconClass="fas fa-chart-line"
            headerBg={GRADIENTS.marks}
            headerExtra={timelineHeader}
          >
            {offlineResults.getStudentExamResults.length > 0 ? (
              <div className="chart-container" style={{ overflowX: 'auto', width: '100%' }}>
                <Line data={chartData} options={chartOptions} height={80} />
              </div>
            ) : (
              <EmptyState message="No exam data available for this period" iconClass="fas fa-chart-bar" />
            )}
          </SectionCard>
        </div>

        {/* ── Marks Table ───────────────────────────────────────────── */}
        <div className="mb-3">
          <SectionCard
            title="Detailed Marks Table"
            iconClass="fas fa-table"
            headerBg={GRADIENTS.purple}
            bodyPadding="16px"
          >
            {marksDetails.length > 0 ? (
              <Row>
                <Col sm={12}>
                  <CardLessDataTableWithOutSearch
                    parentData={marksDetails}
                    particlecolumns={this.articlecolumFunc()}
                  />
                </Col>
              </Row>
            ) : (
              <EmptyState message="No marks recorded for the selected period" iconClass="fas fa-clipboard-list" />
            )}
          </SectionCard>
        </div>

      </div>
    );
  }
}

// ─── Apollo HOC (unchanged) ───────────────────────────────────────────────────

export default withRouter(
  compose(
    graphql(GET_OFFLIE_RESULTS, {
      options: props => ({
        variables: {
          student_mobile: props.stateData.studentData.contact_no.toString(),
          timeline:       parseInt(props.stateData.marksSelectionType),
        },
        fetchPolicy: 'network-only',
      }),
      name: "offlineResults",
    }),
  )(NAOfflineMarksDetails)
);
